import React from 'react';

type Props = {
  fileName: string;
  fileSize: number; // in bytes
  fileUrl: string;
  uploadedAt?: string;
};

const getIcon = (ext: string) => {
  switch (ext) {
    case 'pdf': return '📕';
    case 'apk': return '📱';
    case 'doc':
    case 'docx': return '📘';
    case 'xls':
    case 'xlsx': return '📗';
    case 'zip':
    case 'rar': return '🗜️';
    default: return '📄';
  }
};

const formatSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

const truncateFileName = (name: string, maxLength: number) => {
  if (name.length <= maxLength) return name;

  const extIndex = name.lastIndexOf('.');
  if (extIndex === -1) return name.slice(0, maxLength) + '...';

  const namePart = name.slice(0, extIndex);
  const ext = name.slice(extIndex);

  const shownStart = namePart.slice(0, maxLength - ext.length - 5);
  return `${shownStart}.....${ext}`;
};

export default function FileAttachmentCard({ fileName, fileSize, fileUrl, uploadedAt }: Props) {
  const ext = fileName.split('.').pop()?.toLowerCase() || '';
  const icon = getIcon(ext);

  return (
    <div className="bg-black bg-opacity-20 p-4 rounded-lg w-72 shadow relative mb-2">
      <div className="flex items-center gap-3">
        <div className="text-4xl">{icon}</div>
        <div className="flex-1">
          <div className="text-sm font-medium truncate">
            {truncateFileName(fileName, 24)}
          </div>
          <div className="text-xs text-white-600">{formatSize(fileSize)}, {ext.toUpperCase()} File</div>
        </div>
      </div>
     
      <div className="flex justify-between mt-4 gap-2">
        <a href={`http://localhost:3000${fileUrl}`} target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-black bg-opacity-20 text-white text-sm font-medium py-1">
          Open
        </a>
        <a href={`http://localhost:3000/messages/download/${fileUrl.split('/').pop()}`} download={fileName} className="flex-1 text-center bg-black bg-opacity-20 text-white text-sm font-medium py-1">
          Save as…
        </a>
      </div>
    </div>
  );
}
